import React, { useState, useEffect } from "react";
import { AiOutlineSave } from "react-icons/ai";
import { RxCross2 } from "react-icons/rx";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import TextField from "@mui/material/TextField";
import * as api from "../api/api";
import Spinner from "react-bootstrap/Spinner";
import Loading from "./Loading";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { useLanguage } from "../Components/Localization/LanguageContext";
import strings from "../Components/Localization/strings";

function LobInfo(props) {
  const { language } = useLanguage();
  const pageTitle = "LobInfo";
  const [isEditing, setIsEditing] = useState(false);
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const [isLoading, setLoading] = useState(false);
  const { handleRemoveLob } = props;
  const [lobInfo, setLobInfo] = useState({});
  const [invalidName, setInvalidName] = useState(false);
  const { lob } = props;
  const { manipulateSnackbar } = props;
  const { snackbarData } = props;
  const { refreshLobs } = props;

  useEffect(() => {
    setLobInfo(lob);
  }, [lob]);

  useEffect(() => {
    if (lobInfo.id == "") {
      setEditable(true);
    }
  }, [lobInfo]);
  const handleEdit = () => {
    setOldLobName(lobInfo.name);
    setEditable(true);
    console.log("editing");
  };

  const handleSaveEdit = () => {
    setLoading(true);
    setIsEditing(true);

    let lobList = props.allLobs;

    // don't add it to the lob list if it already exists

    if (lobInfo.id) {
      let nameExists = lobList.some((lob) => lob.name === lobInfo.name);
      if (nameExists) {
        //refuse to add
        setIsEditing(false);
        setLoading(false);
        setInvalidName(true);
      } else {
        api.updateLobById(lobInfo.id, lobInfo).then(() => {
          setIsEditing(false);
          setEditable(false);
          console.log("finished editing");
          setLoading(false);
          setInvalidName(false);
          manipulateSnackbar({
            ...snackbarData,
            message: strings[pageTitle][language].successEditMessage,
            severity: "success",
            show: true,
          });
          refreshLobs();
        });
      }
    } else {
      //to be changed later when we can only use the name of lob without other attributes
      let newLob = {
        ...lobInfo,
      };
      let nameExists = lobList.some((lob) => lob.name === newLob.name);

      if (nameExists) {
        //refuse to add
        setIsEditing(false);
        setLoading(false);
        setInvalidName(true);
      } else {
        api.insertLob(newLob).then((response) => {
          console.log("created new lob with name: " + lobInfo.name);
          console.log("created lob date:" + response.data.object);
          setIsEditing(false);
          setLoading(false);
          setInvalidName(false);
          manipulateSnackbar({
            ...snackbarData,
            message: strings[pageTitle][language].successAddMessage,
            severity: "success",
            show: true,
          });
          refreshLobs();
        });
      }
    }
  };

  const handleDeleteLob = (id) => {
    setLoading(true);
    api.deleteLobById(id).then(() => {
      console.log("deleted lob with id: " + id);
      setLoading(false);

      manipulateSnackbar({
        ...snackbarData,
        message:
          strings[pageTitle][language].successDeleteMessage + lobInfo.name,
        severity: "success",
        show: true,
      });
      refreshLobs();
    });
  };

  const handleCancel = () => {
    props.setIsAdding(false);
    if (lobInfo.id) {
      setLobInfo({
        ...lobInfo,
        name: oldLobName,
      });
      setEditable(false);
    } else {
      // TODO : remove the lob from the list
      handleRemoveLob(lobInfo.id);
    }
  };
  const handleNameChange = (e) => {
    setLobInfo({
      ...lobInfo,
      name: e.target.value,
    });
  };

  const [editable, setEditable] = useState(false);
  const [oldLobName, setOldLobName] = useState("");
  return (
    <div className="team-info">
      {isLoading ? <Loading /> : ""}
      {editable ? (
        <>
          <div className="team-info__name">
            <TextField
              id="outlined-basic"
              label="Lob name"
              variant="outlined"
              size="small"
              value={lobInfo.name}
              onChange={handleNameChange}
              error={invalidName}
            />
            {invalidName && (
              <div
                style={{ color: "red", marginTop: "8px", fontSize: "0.75rem" }}
              >
                {strings[pageTitle][language].duplicatedLoBName}
              </div>
            )}
          </div>

          <div className="team-info__buttons">
            <button className="button-with-icon" onClick={handleSaveEdit}>
              {!isEditing ? (
                <AiOutlineSave />
              ) : (
                <Spinner
                  as="span"
                  animation="border"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                />
              )}
            </button>
            <button className="button-with-icon" onClick={handleCancel}>
              <RxCross2 />
            </button>
          </div>
        </>
      ) : (
        <>
          <div className="team-info__name">{lobInfo.name}</div>
          <div className="team-info__buttons">
            <button
              style={{
                border: "none",
                outline: "none",
                backgroundColor: "rgba(255, 0, 0, 0)",
                color: "#00a0e5",
              }}
              className="icon-btn"
              onClick={handleEdit}
            >
              <EditIcon />
            </button>
            <button
              style={{
                border: "none",
                outline: "none",
                backgroundColor: "rgba(255, 0, 0, 0)",
                color: "#00a0e5",
              }}
              className="icon-btn"
              onClick={() => setShow(true)}
            >
              <DeleteIcon />
            </button>
          </div>
        </>
      )}
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>
            {strings[pageTitle][language].deleteModalTitle}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>{strings[pageTitle][language].deleteModalBody}</Modal.Body>
        <Modal.Footer>
          <Button variant="light" onClick={handleClose}>
            {strings[pageTitle][language].cancel}
          </Button>
          <Button variant="danger" onClick={() => handleDeleteLob(lobInfo.id)}>
            {strings[pageTitle][language].delete}
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default LobInfo;
